<template>
  <div class="list-user-photo-container">
    <ul class="list-user-photo">
      <template v-for="(image, key) in images">
        <li v-if="key < max_photo" :key="key" class="list-user-photo__item" @click.prevent="openModalUserPhotos(key)">
          <img
            :src="mainImage(image.name) || ''"
            :width="section == 'popular-review' ? 80 : 60"
            :height="section == 'popular-review' ? 80 : 60"
            class="list-user-photo__img"
            :class="{ 'list-user-photo__img-popular': section == 'popular-review' }"
            loading="lazy"
            :alt="image.name"
            @error="imageErrorHandler($event)"
          />
          <div v-if="key === max_photo - 1 && images.length > max_photo" class="list-user-photo__last-item">
            <slot name="last-item">
              <p v-if="displayRemainingPhoto" class="list-user-photo__last-item-text text-uppercase remaining-photo">
                +{{ images.length - max_photo }}
              </p>
              <p v-else class="list-user-photo__last-item-text">See All<br />{{ images.length }}<br />Photos</p>
            </slot>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
/* eslint-disable vue/prop-name-casing */
export default {
  name: 'list-user-photo',
  props: {
    created_at: {
      required: true,
    },
    images: {
      required: true,
    },
    user: {
      required: true,
    },
    averageRating: {
      required: true,
    },
    details: {
      required: true,
    },
    max_photo: {
      type: Number,
      required: false,
      default: () => 5,
    },
    displayRemainingPhoto: {
      type: Boolean,
      required: false,
      default: false,
    },
    section: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    openModalUserPhotos(key) {
      const data = [];
      this.$SO.each(this.images, (key, image) => {
        image.created_at = this.created_at;
        image.user = this.user;
        image.url = image.name;
        image.average_rating = this.averageRating;
        image.details = this.details;
        data.push(image);
      });
      this.$store.commit('setOpenModal', {
        stateName: 'userPhotos',
        newVal: true,
      });
      this.$store.commit('setInitialIndexSlideGlobalUserPhotos', key);
      this.$store.commit('setTotalUserPhotoGlobalUserPhotos', this.images.length);
      this.$store.commit('setDataGlobalUserPhotos', data);
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=160' : 'w=180',
        image: src,
      });
    },
    imageErrorHandler(e) {
      e.target.src = '/assets/img/broken-img-review.png';
    },
  },
};
</script>
<style lang="scss" scoped>
list-user-photo-container {
  display: flex;
  overflow-x: auto;
}

.list-user-photo {
  display: flex;
  list-style: none;
}

.list-user-photo__item {
  display: inline-block;
  position: relative;
  margin-right: 10px;
}
.list-user-photo {
  &__img {
    object-fit: cover;
    aspect-ratio: auto 1 / 1;
    border-radius: 11.5px;
  }
}
.list-user-photo__img-popular {
  width: 56px !important;
  height: 56px !important;
}

.list-user-photo__last-item {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  opacity: 0.8;
  background: #231f20;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 4px;
}

.list-user-photo__last-item-text {
  margin: 0;
  font: 12px/15px 'Lato-Bold', sans-serif;
  letter-spacing: 0;
  color: #ffffff;
}
</style>
